export const MOBILE_WIDTH_BREAKPOINT = 850;
export const TABLET_WIDTH_BREAKPOINT = 1200;

export enum DeviceSizes {
  MobileMaxWidth = 'max-width: 850px',
  TabletMinWidth = 'min-width: 851px',
  TabletMaxWidth = 'max-width: 1200px',
  DesktopMinWidth = 'min-width: 1201px',
}
